/**
 * Created by slava on 04.10.2023
 */

const SimpleAltProgressView = cc.Node.extend({
    ctor: function () {
        const styles = cleverapps.styles.SimpleAltProgressView;
        const location = cleverapps.meta.getSelectedLocation();

        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);
        this.setAlignment(styles);

        const bg = new cc.Scale9Sprite(bundles.simple.frames.simple_progress_bg);
        if (styles.bg.size) {
            bg.setContentSize(styles.bg.size);
        }
        bg.setAlignment(styles.bg);
        this.addChild(bg);

        const titleMsg = "background_name_" + location.getStage();
        const title = cleverapps.UI.generateOnlyText(Messages.get(titleMsg), cleverapps.styles.FONTS.SIMPLE_PROGRESS_TEXT);
        title.fitTo(styles.title.width, styles.title.height);

        const icon = this.icon = new cc.Sprite(bundles[location.getIconBundle(location.getStage())].urls.icon);
        if (styles.icon && styles.icon.size) {
            cleverapps.UI.fitToBox(icon, styles.icon.size);
        }
        const iconWrapper = this.iconWrapper = cleverapps.UI.wrapWithPadding(icon, 0);
        const label = new cleverapps.Layout([iconWrapper, title], {
            direction: cleverapps.UI.HORIZONTAL,
            reversed: styles.label.reversed,
            margin: styles.label.margin
        });
        label.setAlignment(styles.label);
        this.addChild(label);

        if (connector.info.isMobile) {
            this.setScale(styles.mobileScale);
            this.baseScale = this.scale;
        }

        this.progressBar = new StarsProgressBar({
            width: styles.bar.width
        });
        this.progressBar.setAlignment(styles.bar);
        this.addChild(this.progressBar);

        cleverapps.UI.onClick(this, this.onClick.bind(this));

        cleverapps.aims.registerTarget("locationProgress", this, {
            controls: ["progress_view"],
            flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
            duration: 1000
        });

        cleverapps.meta.getSelectedLocation().on("nextStage", this.onNextStage.bind(this), this);
        cleverapps.meta.getSelectedLocation().on("showForce", this.showForce.bind(this), this);
        cleverapps.meta.getSelectedLocation().on("progressChanged", this.updateProgress.bind(this), this);
    },

    onClick: function () {
        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }
        cleverapps.effects.fire("ui.button.click");
        cleverapps.effects.fire("ui.button.haptic");

        cleverapps.focusManager.display({
            focus: "BackgroundsAltWindow",
            action: function (f) {
                new BackgroundsAltWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    onNextStage: function () {
        this.runProgressAnimation();

        this.runAvatarAnimation();
    },

    updateProgress: function () {
        this.progressBar.updateProgress();
    },

    runProgressAnimation: function () {
        const styles = cleverapps.styles.SimpleAltProgressView;

        const progressBarAnimation = new cleverapps.Spine(bundles.simple.jsons.progress_bar_spark_json);
        this.progressBar.addChild(progressBarAnimation);
        progressBarAnimation.setAlignment(styles.spark);
        progressBarAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            new cc.CallFunc(() => {
                progressBarAnimation.setAnimation(0, "animation", false);
                progressBarAnimation.setCompleteListenerRemove();
            })
        ));
    },

    runAvatarAnimation: function () {
        this.runAction(new cc.Sequence(
            new cc.CallFunc(function () {
                StandartAnimations.rays(this.icon);
                cleverapps.effects.fire("location.simple.win");
            }.bind(this))
        ));
    },

    showForce: function () {
        cleverapps.focusManager.setEventNodes([this]);
        FingerView.hintTap(this, {
            runOnce: true
        });
    }
});

cleverapps.styles.SimpleAltProgressView = {
    width: 440,
    height: 171,
    mobileScale: 0.85,
    x: { align: "center" },
    y: { align: "bottom", dy: 320 },

    bg: {
        x: { align: "center" },
        y: { align: "center" }
    },

    title: {
        width: 190,
        height: 100
    },

    label: {
        margin: 20,
        x: { align: "center" },
        y: { align: "center", dy: 34 }
    },

    bar: {
        width: 390,
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -40 }
    },

    spark: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
